module.exports = __webpack_public_path__ + "img/hk.c1b9d3ff.svg";